import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { LabelI18nService } from 'src/app/core/_services/label-i18n.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import HC_exporting from 'highcharts/modules/exporting';
import HC_offlineExporting from 'highcharts/modules/offline-exporting';
import { IndicatorCodes } from 'src/app/core/_enums/indicators.code';
import { SationImpactColor } from 'src/app/core/_enums/station.impact.color';
import { Impact } from 'src/app/core/_models/impact';
import { Indicator } from 'src/app/core/_models/indicator';
import { PdfPictures } from 'src/app/core/_models/pdfPictures';
import { ProjectEcoPro } from 'src/app/core/_models/projectEcoPro';
import { Solution } from 'src/app/core/_models/solution';
import { HIGHCHARTS_EXPORTING, HIGHCHARTS_TRANSLATIONS } from 'src/constants/graph.constants';
import { SvgToPngService } from '../../../core/_utils/svgToPng.service';

HC_more(Highcharts);
HC_exporting(Highcharts);
HC_offlineExporting(Highcharts);

let componentContext: any;

@Component({
  selector: 'app-bar-indicators-detailed-byStations',
  templateUrl: './bar-indicators-detailed-byStations.component.html',
  styleUrls: ['./bar-indicators-detailed-byStations.component.scss']
})
export class BarIndicatorsDetailedByStationsComponent implements OnChanges, OnInit {
  @Input() projectData: ProjectEcoPro = {};
  @Input() indicators: Indicator[] = [];
  @Input() isEcoPro: boolean = true;
  @Input() synthese: any;
  chart: any;

  indicatorComparatif: Indicator = {
    isChecked: false
  };

  private defaultApplied = false;
  updateFlag: boolean = false;
  totalsRef: number[] = [];

  // Highcharts config

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    chart: {
      type: 'bar'
    },
    lang: HIGHCHARTS_TRANSLATIONS,
    title: {
      text: 'Comparaison par module et scénario'
    },
    legend: {
      itemStyle: {
        color: '#333333',
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 'bold',
        textOverflow: 'ellipsis'
      }
    },
    colors: ['#7cb5ec', '#434348', '#f7a35c', '#8085e9', '#f15c80', '#e4d354', '#2b908f', '#f45b5b', '#91e8e1'],
    exporting: HIGHCHARTS_EXPORTING,
    xAxis: {
      //crosshair: true,
      gridLineWidth: 6,
      lineWidth: 0,
      labels: {
        style: {
          fontWeight: 'bold',
          color: 'red'
        }
      }
    },
    yAxis: {
      min: 0,
      gridLineWidth: 0,
      title: {
        text: componentContext?.labelI18n.indicatorLabel(componentContext?.indicatorComparatif)
      }
    },
    credits: {
      enabled: true
    },
    tooltip: {
      headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        },
        groupPadding: 0
      }
      /*series: {
        dataLabels: [
          {
            enabled: true,
            useHTML: true,
            y: -25,
            crop: false,
            overflow: 'allow',
            formatter: function () {
              if (this.colorIndex == 0) {
                componentContext.totalsRef.splice(this.point.index, 0, this.y);
                return '<span style="background-color: lightgray; font-size: 10px; padding: 2px; border:1px solid"> Ref. </span>';
              } else {
                if (this.y && this.y != 0) {
                  const percentageDiff =
                    (100 *
                      (this.y - componentContext.totalsRef[this.point.index])) /
                    componentContext.totalsRef[this.point.index];
                  if (!isNaN(percentageDiff)) {
                    const displayValue =
                      percentageDiff == 0
                        ? '&nbsp' + '-' + '&nbsp'
                        : percentageDiff > 0
                        ? '+' + Math.round(percentageDiff) + '%'
                        : Math.round(percentageDiff) + '%';
                    const backgroundColor =
                      percentageDiff < 0
                        ? '#25e043'
                        : percentageDiff > 0
                        ? '#ff4c4c'
                        : 'lightgray';

                    return (
                      '<span style="background-color:' +
                      backgroundColor +
                      '; font-size: 10px; padding: 2px; border:1px solid">' +
                      displayValue +
                      '</span>'
                    );
                  } else {
                    return '';
                  }
                } else {
                  return '';
                }
              }
            },
          },
          {
            enabled: true,
            allowOverlap: true,
            format: '{point.y}',
            crop: false,
            overflow: 'allow',
          },
        ],
      },*/
      /*column: {
        pointPadding: 3.9,
        borderWidth: 0,
      },*/
    }
  };

  constructor(public labelI18n: LabelI18nService) {
    componentContext = this;
  }

  ngOnChanges() {
    if (!this.defaultApplied && this.indicators.length > 0 && this.synthese?.length > 0) {
      this.defaultApplied = true;
      const coIndicator = this.indicators.find((i: Indicator) => i.code === IndicatorCodes.CO2);
      if (coIndicator) {
        coIndicator.isChecked = true;
        this.indicatorComparatif = coIndicator;
      }
    }
    if (this.indicatorComparatif) this.formatDataForGraph();
  }

  ngOnInit() {
    if (this.isEcoPro) {
      this.indicators = this.indicators.filter((indicator) => indicator.code == IndicatorCodes.CO2 || indicator.code == IndicatorCodes.Energie);
    }
  }

  onChangeIndicatorSelect(cb: MatCheckboxChange, indicator: Indicator) {
    this.indicators.forEach((i) => (i.isChecked = false));
    if (cb.checked) {
      indicator.isChecked = true;
      this.indicatorComparatif = indicator;
      this.formatDataForGraph();
    } else {
      this.indicatorComparatif = { isChecked: false };
    }
  }

  async generateCharts(indicators: Indicator[]) {
    let pdfCharts: PdfPictures = {
      coCharts: [],
      energyCharts: [],
      gncharts: [],
      tkCharts: [],
      synthetiqueResultENcharts: [],
      synthetiqueResultCOcharts: []
    };

    var options = Highcharts.merge(Highcharts.getOptions().exporting, { type: 'application/pdf' /*,sourceWidth:'600px'*/ });

    for (let indicator of indicators) {
      this.indicatorComparatif = indicator;
      this.formatDataForGraph();
      switch (indicator.code) {
        case 'EN':
          var base64 = await SvgToPngService.convertSVGToPNG(this.chart.getSVG(options), 1200, 800);
          if (base64 != null) pdfCharts.energyCharts?.push(base64);
          break;
        case 'CO':
          var base64 = await SvgToPngService.convertSVGToPNG(this.chart.getSVG(options), 1200, 800);
          if (base64 != null) pdfCharts.coCharts?.push(base64);
          break;
        case 'PR':
          var base64 = await SvgToPngService.convertSVGToPNG(this.chart.getSVG(options), 1200, 800);
          if (base64 != null) pdfCharts.gncharts?.push(base64);
          break;
        case 'TK':
          var base64 = await SvgToPngService.convertSVGToPNG(this.chart.getSVG(options), 1200, 800);
          if (base64 != null) pdfCharts.tkCharts?.push(base64);
          break;
        default:
          break;
      }
    }
    return pdfCharts;
  }

  generateArray(obj: any) {
    return Object.keys(obj).map((key) => {
      return { key: key, value: obj[key] };
    });
  }

  formatDataForGraph() {
    let series: { name: string | undefined; data: number[] }[] = [];
    const stationImpactsNames: string[] = [];
    const stationsImpactsForSelectedIndicator: Impact[] = [];
    const solutionsData: Solution[] = [];
    if (this.indicatorComparatif.code && this.synthese && this.synthese.length > 0) {
      let specificSynthese = this.synthese.find((row: any) => row.code === this.indicatorComparatif.code);
      specificSynthese.solutions.forEach((solution: any) => {
        let stationImpact: Impact = {};
        let headers = this.generateArray(solution.rows[0].values);
        headers.forEach((header: any) => {
          stationImpact = {};
          switch (header.key) {
            case SationImpactColor.BuildTransportCostIn.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.color = SationImpactColor.BuildTransportCostIn.value;
              stationImpact.solutionId = solution.solutionId;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              stationImpact.displayName = specificSynthese.headers.BuildTransportCostIn;
              break;
            case SationImpactColor.MaterialMakingCost.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.solutionId = solution.solutionId;
              stationImpact.displayName = specificSynthese.headers.MaterialMakingCost;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              break;
            case SationImpactColor.InitialTransportCost.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.solutionId = solution.solutionId;
              stationImpact.displayName = specificSynthese.headers.InitialTransportCost;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              break;
            case SationImpactColor.MaterialCost.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.solutionId = solution.solutionId;
              stationImpact.displayName = specificSynthese.headers.MaterialCost;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              break;
            case SationImpactColor.WorkingCost.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.solutionId = solution.solutionId;
              stationImpact.displayName = specificSynthese.headers.WorkingCost;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              break;
            case SationImpactColor.BuildTransportCostOut.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.solutionId = solution.solutionId;
              stationImpact.displayName = specificSynthese.headers.BuildTransportCostOut;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              break;
            case SationImpactColor.NaturalAggregates.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.color = SationImpactColor.NaturalAggregates.value;
              stationImpact.solutionId = solution.solutionId;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              stationImpact.displayName = specificSynthese.headers.NaturalAggregates;
              break;
            case SationImpactColor.RecycledMaterials.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.color = SationImpactColor.RecycledMaterials.value;
              stationImpact.solutionId = solution.solutionId;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              stationImpact.displayName = specificSynthese.headers.RecycledMaterials;
              break;
            case SationImpactColor.AsphaltAggregates.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.color = SationImpactColor.AsphaltAggregates.value;
              stationImpact.solutionId = solution.solutionId;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              stationImpact.displayName = specificSynthese.headers.AsphaltAggregates;
              break;
            case SationImpactColor.ReusedSpoil.toString():
              stationImpact.value = parseFloat(header.value);
              stationImpact.color = SationImpactColor.ReusedSpoil.value;
              stationImpact.solutionId = solution.solutionId;
              stationImpact.scenarioSolutionAssociationId = solution.scenarioSolutionAssociationId;
              stationImpact.displayName = specificSynthese.headers.ReusedSpoil;
              break;
            default:
              break;
          }
          if (Object.keys(stationImpact).length !== 0) {
            stationsImpactsForSelectedIndicator.push(stationImpact);
          }
          if (stationImpact.displayName && !stationImpactsNames.includes(stationImpact.displayName)) {
            stationImpactsNames.push(stationImpact.displayName);
          }
        });
      });
      specificSynthese.solutions.forEach((solution: any) => {
        stationImpactsNames.forEach((stationImpactName) => {
          let ceuValueForStationType = 0;

          stationsImpactsForSelectedIndicator.forEach((stationImpact) => {
            if (stationImpact.solutionId == solution.solutionId && stationImpact.scenarioSolutionAssociationId == solution.scenarioSolutionAssociationId && stationImpact.value != null && stationImpactName == stationImpact.displayName) {
              ceuValueForStationType += stationImpact.value;
            }
          });

          let solutionRef = solutionsData.find((solutionData) => solutionData.id == solution.solutionId);

          if (solutionRef == null) {
            solutionsData.push({
              id: solution.solutionId,
              displayName: solution.displayName,
              dataForGraph: [Number(ceuValueForStationType.toFixed(2))]
            });
          } else {
            solutionRef.dataForGraph?.push(Number(ceuValueForStationType.toFixed(2)));
          }
        });
      });
      solutionsData.forEach((solutionData) => {
        if (solutionData.dataForGraph) {
          series.push({
            name: solutionData.displayName,
            data: solutionData.dataForGraph
          });
        }
      });

      this.chartOptions.xAxis = {
        categories: stationImpactsNames,
        title: {
          text: null
        },
        gridLineWidth: 3,
        lineWidth: 0,
        labels: {
          style: {
            fontWeight: 'bold'
          }
        }
      };

      this.chartOptions.yAxis = {
        title: {
          text: componentContext?.labelI18n.indicatorLabelWithUnit(componentContext?.indicatorComparatif)
        },
        gridLineWidth: 1
      };

      this.chartOptions.series = series as Highcharts.SeriesOptionsType[];

      componentContext.totalsRef = [];

      stationImpactsNames.forEach(() => {
        componentContext.totalsRef.push(0);
      });

      this.updateFlag = true;
      this.chart = Highcharts.chart('hidden-container', this.chartOptions);
    }
  }
}
